import { render, staticRenderFns } from "./GAndCategoriesPost.vue?vue&type=template&id=e8692d1a"
import script from "./GAndCategoriesPost.vue?vue&type=script&lang=js"
export * from "./GAndCategoriesPost.vue?vue&type=script&lang=js"
import style0 from "./GAndCategoriesPost.vue?vue&type=style&index=0&id=e8692d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports